export default "__VITE_ASSET__DmNYpLUS__"